export { default } from "ember-router-helpers/helpers/url-for.js";
